// ABOUTME: Progress indicator dots for onboarding steps
// ABOUTME: Shows current, completed, and upcoming steps

interface StepIndicatorProps {
  steps: number;
  currentStep: number;
}

export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="step-indicator" role="progressbar" aria-valuenow={currentStep + 1} aria-valuemin={1} aria-valuemax={steps}>
      {Array.from({ length: steps }, (_, i) => {
        let className = "step-indicator__dot";
        if (i < currentStep) {
          className += " step-indicator__dot--completed";
        } else if (i === currentStep) {
          className += " step-indicator__dot--current";
        } else {
          className += " step-indicator__dot--upcoming";
        }
        return (
          <div
            key={i}
            className={className}
            aria-label={`Step ${i + 1} of ${steps}${i === currentStep ? " (current)" : ""}`}
          />
        );
      })}
    </div>
  );
}
